import { render, staticRenderFns } from "./ChartConsumption.vue?vue&type=template&id=37b18d4f&"
import script from "./ChartConsumption.vue?vue&type=script&lang=js&"
export * from "./ChartConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports